module.exports = __webpack_public_path__ + "b50028b729fa55a9ac6750f59d9f2b9a.png";